
import React from 'react';
import { format, parseISO, addDays } from 'date-fns';
import { formatDecimalPace } from '../../utils/formatWorkout';


export const PeriodTable = ({ rows, periodKey, period, t }) => {
  const formatPeriod = (row) => {
    const raw = row[periodKey];
    if (!raw) return '—';
    try {
      const date = typeof raw === 'string' ? parseISO(raw) : new Date(raw);
      if (period === 'weekly') {
        const end = addDays(date, 6);
        return `${format(date, 'dd.MM')} - ${format(end, 'dd.MM')}`;
      } else if (period === 'monthly') {
        return format(date, 'MM.yyyy');
      }
      return raw;
    } catch {
      return raw;
    }
  };

  return (
    <div className="bg-white rounded-xl shadow overflow-x-auto">
      <table className="min-w-full text-sm">
        <thead className="bg-gray-50 text-gray-600">
          <tr>
            <th className="px-3 py-2 text-left">{t('journal.col_period')}</th>
            <th className="px-3 py-2 text-right">{t('journal.col_total_km')}</th>
            <th className="px-3 py-2 text-right">{t('journal.col_avg_pace')}</th>
            <th className="px-3 py-2 text-right">{t('journal.col_workouts_count')}</th>
            <th className="px-3 py-2 text-right">{t('journal.col_elevation')}</th>
            <th className="px-3 py-2 text-center">{t('journal.col_avg_rpe')}</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.week_start || row.month_start} className="border-t border-gray-100">
              <td className="px-3 py-2">{formatPeriod(row, period)}</td>
              <td className="px-3 py-2 text-right">{row.total_distance_km}</td>
              <td className="px-3 py-2 text-right">{formatDecimalPace(row.avg_pace)}</td>
              <td className="px-3 py-2 text-right">{row.workouts_count}</td>
              <td className="px-3 py-2 text-right">{Math.round(row.total_elevation_gain_m)}</td>
              <td className="px-3 py-2 text-center" title={row.avg_rpe != null ? `avg RPE ${row.avg_rpe}` : undefined}>
                {row.avg_rpe != null ? row.avg_rpe.toFixed(1) : '—'}
              </td>
            </tr>
          ))}
          {rows.length === 0 && (
            <tr><td colSpan={6} className="px-3 py-6 text-center text-gray-400">{t('journal.no_data')}</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
};